import * as React from 'react';
import { createRegisteredContext } from 'react-singleton-context';
import { isEqual } from 'lodash';
import useTableCheckboxes from '../hooks/useTableCheckboxes';
import { useDataResourceContext } from './DataResourceContext';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectedItemsContext = createRegisteredContext('ContainerTableSelectedItemsContext', undefined);
export const useSelectedItems = () => {
  const context = React.useContext(SelectedItemsContext);
  if (!context) {
    throw new Error('useSelectedItems should be used within a SelectedItemsProvider');
  }
  return context;
};
/**
 * @ignore - internal component.
 */
export function SelectedItemsProvider({
  children,
  withCheckbox
}) {
  const {
    data,
    isLoading
  } = useDataResourceContext();
  const {
    clearSelectedItems,
    getCheckboxProps,
    getTitleCheckboxProps,
    selectedItems
  } = useTableCheckboxes({
    data,
    withCheckbox
  });
  const dataRef = React.useRef(data);

  // clear selectedItems if isLoading or its a new data
  React.useEffect(() => {
    const isEqualData = isEqual(dataRef.current, data);
    if (!isEqualData) {
      dataRef.current = data;
      clearSelectedItems();
    } else if (isLoading) {
      clearSelectedItems();
    }
  }, [data, isLoading, clearSelectedItems]);
  const values = React.useMemo(() => ({
    clearSelectedItems,
    getCheckboxProps,
    getTitleCheckboxProps,
    selectedItems
  }), [clearSelectedItems, getCheckboxProps, getTitleCheckboxProps, selectedItems]);
  return /*#__PURE__*/_jsx(SelectedItemsContext.Provider, {
    value: values,
    children: children
  });
}